<template>
  <sc-text tag="h3" v-if="fields && fields.heading" :field="fields.heading" />
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-FAQ-Item-Headline',
  components: {
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
